// This is a config for the Word Complexity assessment. As such, this helper is not bundled in Yoast SEO.
export default {
	wordLength: 7,
	doesUpperCaseDecreaseComplexity: true,
};
